// enci.carousel.js
// TODO: refactor busted this page, so we're back to the original version

import $ from 'jquery';
import 'owl.carousel';
import { debugLog } from './enci.log.js';

/**
 * Initializes banner sliders on the page using the Owl Carousel plugin.
 *
 * @function setBannerSlider
 */
export function setBannerSlider() {
  debugLog('setBannerSlider');

  const $carousels = $('.banner-slider');

  if (!$carousels.length) {
    debugLog('setBannerSlider >> No banner sliders exist.', { type: 'error' });
    return;
  }

  $carousels.each((_, element) => {
    const $carousel = $(element);
    $carousel.owlCarousel({
      items: 1,
      loop: true,
      dots: $carousel.data('dots'),
      nav: $carousel.data('nav'),
      animateIn: 'fadeIn',
      animateOut: 'fadeOut',
      autoplay: true,
      autoplayTimeout: 6000,
      navText: [
        '<span class="fas fa-chevron-left"></span>',
        '<span class="fas fa-chevron-right"></span>',
      ],
    });
  });
}

/**
 * Initializes Owl Carousel instances with customized settings based on data attributes.
 *
 * @function initializeOwlCarousel
 * @param {string} selector - The CSS selector for the carousel element.
 * @param {boolean} isLazyLoad - Whether to enable lazy loading for the carousel.
 */
export function initializeOwlCarousel(selector, isLazyLoad = false) {
  debugLog(`initializeOwlCarousel with selector ${selector}`);

  const $carousel = $(selector);

  if (!$carousel.length) {
    debugLog(`initializeOwlCarousel >> No carousels exist for ${selector}.`, { type: 'error' });
    return;
  }

  $carousel.owlCarousel({
    lazyLoad: isLazyLoad,
    lazyLoadEager: 1,
    items: $carousel.data('items'),
    margin: $carousel.data('margin'),
    loop: true,
    center: $carousel.data('center'),
    nav: $carousel.data('nav'),
    navText: [
      '<span class="fas fa-long-arrow-alt-left"></span>',
      '<span class="fas fa-long-arrow-alt-right"></span>',
    ],
    slideBy: $carousel.data('slideby'),
    slideTransition: $carousel.data('transition'),
    dots: $carousel.data('dots'),
    autoplay: $carousel.data('autoplay'),
    autoplayTimeout: $carousel.data('autoplay-timeout'),
    autoplayHoverPause: true,
    smartSpeed: $carousel.data('smartspd'),
    autoplaySpeed: $carousel.data('autospd'),
    responsive: {
      0: { items: $carousel.data('xs-items') || 1 },
      576: { items: $carousel.data('sm-items') || 1 },
      768: { items: $carousel.data('md-items') || 2 },
      1024: { items: $carousel.data('lg-items') || 2 },
      1200: { items: $carousel.data('items') || 3 },
    },
    stageClass: 'owl-stage',
  });
}
